<div class="allergen_msg_main_div">
    <div class="allergen_msg_txt_div">{{data}}</div>
    <div style="text-align: center;margin: 10px 0; margin-top: 30px;">
        <button type="button" class="allergen_msg_okay_btn" (click)="close()">OK</button>
    </div>
</div>



<style>
    ::ng-deep .allergen_msg_dialog .mat-dialog-container {
        padding: 15px !important;
    }
    .allergen_msg_main_div {
        max-height: 80vh;
        max-width: 300px;
    }

    .allergen_msg_txt_div {
        font-size: 16px;
        color: #616060;
        line-height: 27px;
    }

    .allergen_msg_okay_btn {
        width: 156px;
        height: 32px;
        border-radius: 50px;
        border: 1px solid #353535;
        color: #353535;
        font-size: 14px ;
        font-weight: 500;
        background: transparent;
    }
</style>